import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Typography, CircularProgress, Card, CardActionArea, Chip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import PersonIcon from "@mui/icons-material/Person";
import { AuthContext } from "../context/AuthContext";
import Header from "../components/Header";
import { useSnack } from "../hooks/useSnack";
import { getSharedWithMe } from "../service/albumApi";

export default function SharedWithMe() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { state: user } = useContext(AuthContext);
  const { showSnack, Snack } = useSnack();
  const col = theme.custom.mymodal;

  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate("/connexion"); return; }
    getSharedWithMe()
      .then(setAlbums)
      .catch((e) => showSnack(e.message, "error"))
      .finally(() => setLoading(false));
  }, [user, navigate]); // eslint-disable-line

  if (loading) {
    return (
      <>
        <Header />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
          <CircularProgress sx={{ color: col.text }} />
        </Box>
      </>
    );
  }

  return (
    <>
      <Header />
      <Box sx={{ maxWidth: 1100, mx: "auto", p: { xs: 2, sm: 3 } }}>
        <Typography variant="h5" sx={{ color: col.text, fontWeight: "bold", mb: 3 }}>
          Partagé avec moi
        </Typography>

        {albums.length === 0 ? (
          <Typography sx={{ color: col.text, opacity: 0.5, textAlign: "center", mt: 8 }}>
            Personne ne t'a encore partagé d'album.
          </Typography>
        ) : (
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }, gap: 2 }}>
            {albums.map((album) => (
              <Card key={album.album_id} sx={{ bgcolor: col.main, border: `1px solid ${col.text}22` }}>
                <CardActionArea onClick={() => navigate(`/albums/${album.album_id}`)} sx={{ p: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                    <FolderSharedIcon sx={{ color: col.text, opacity: 0.6, fontSize: "2rem", mt: 0.2 }} />
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography sx={{ color: col.text, fontWeight: 600, fontSize: "1rem",
                        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {album.name}
                      </Typography>
                      {album.description && (
                        <Typography sx={{ color: col.text, opacity: 0.6, fontSize: "0.78rem", mt: 0.3,
                          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {album.description}
                        </Typography>
                      )}
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.8, flexWrap: "wrap" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
                          <PersonIcon sx={{ fontSize: "0.85rem", color: col.text, opacity: 0.5 }} />
                          <Typography sx={{ color: col.text, opacity: 0.5, fontSize: "0.75rem" }}>
                            {album.owner?.users_pseudo}
                          </Typography>
                        </Box>
                        <Chip label={`${album.media_count} photo${album.media_count !== 1 ? "s" : ""}`}
                          size="small" sx={{ bgcolor: col.text + "18", color: col.text, fontSize: "0.7rem" }} />
                      </Box>
                    </Box>
                  </Box>
                </CardActionArea>
              </Card>
            ))}
          </Box>
        )}
      </Box>
      {Snack}
    </>
  );
}
